import $ from 'jquery';
import Modaal from './Modaal';

export default class Lightbox {
  constructor(context) {
    // Replace Lightbox lightframe functionality with Modaal.
    $('.open-lightframe', context).each((i, element) => {
      if (!element.Modaal) {
        const selector = '.node-header a, .field-image a, .link-read-more a';
        element.Modaal = new Modaal(element, selector);
      }
    });

    // Replace Lightbox slideshow functionality with Modaal.
    $('.te-open-slideshow .node, .te-open-slideshow.node', context).each((i, element) => {
      if (!element.Modaal) {
        const selector = '.field-image a';
        element.Modaal = new Modaal(element, selector);
      }
    });

    // Replace Lightbox and Lighframe straggelers.
    $('[rel^=lightbox], [rel^=lightframe]', context).closest('.node').each((i, element) => {
      const notValid = element.parentNode.classList.contains('dd-hover-dependencies');
      if (!element.Modaal && !notValid) {
        // const selector = '.node-header a, .field-image a, .link-read-more a';
        const selector = '.field-image a';
        element.Modaal = new Modaal(element, selector);
      }
    });
  }
}
